(() => {
  const root = document.documentElement;
  root.classList.remove('no-js');
  root.classList.add('js');

  const announce = (message) => {
    const region = document.querySelector('[data-live-region]');
    if (!region) return;
    region.textContent = '';
    window.setTimeout(() => {
      region.textContent = message;
    }, 50);
  };

  const initProductSection = (section) => {
    if (section.dataset.productReady === 'true') return;

    const variantSelect = section.querySelector('[data-variant-select]');
    const variantsNode = section.querySelector('[data-product-variants]');
    if (!variantSelect || !variantsNode) return;

    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (_error) {
      return;
    }

    const variantsById = new Map(variants.map((variant) => [String(variant.id), variant]));
    const priceContainer = section.querySelector('[data-price-container]');
    const currentPrice = priceContainer?.querySelector('[data-price-current]');
    const comparePrice = priceContainer?.querySelector('[data-price-compare]');
    const compareLabel = priceContainer?.querySelector('[data-price-compare-label]');
    const skuRow = section.querySelector('[data-variant-sku-row]');
    const skuValue = section.querySelector('[data-variant-sku]');
    const inventory = section.querySelector('[data-variant-inventory]');
    const quantity = section.querySelector('[data-variant-quantity]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addLabel = section.querySelector('[data-add-to-cart-label]');
    const sellingPlanField = section.querySelector('[data-selling-plan-field]');
    const sellingPlanSelect = section.querySelector('[data-selling-plan-select]');

    const updateVariant = (variant, updateUrl = true) => {
      if (!variant) return;

      if (currentPrice) currentPrice.textContent = variant.price;
      const isOnSale = Boolean(variant.compareAtPrice);
      priceContainer?.classList.toggle('price--on-sale', isOnSale);
      if (comparePrice) {
        comparePrice.hidden = !isOnSale;
        comparePrice.textContent = variant.compareAtPrice || '';
      }
      if (compareLabel) compareLabel.hidden = !isOnSale;

      if (skuRow && skuValue) {
        skuValue.textContent = variant.sku || '';
        skuRow.hidden = !variant.sku;
      }

      if (inventory) {
        const threshold = Number(inventory.dataset.lowStockThreshold || 0);
        if (!variant.available) {
          inventory.textContent = 'Actuellement indisponible';
        } else if (variant.inventoryManagement && variant.inventoryQuantity > 0 && variant.inventoryQuantity <= threshold) {
          inventory.textContent = `Plus que ${variant.inventoryQuantity} en stock`;
        } else {
          inventory.textContent = 'En stock';
        }
      }

      if (quantity) {
        const minimum = Number(variant.quantityMin || 1);
        quantity.min = String(minimum);
        quantity.step = String(variant.quantityIncrement || 1);
        if (variant.quantityMax == null) quantity.removeAttribute('max');
        else quantity.max = String(variant.quantityMax);
        if (Number(quantity.value) < minimum) quantity.value = String(minimum);
        if (variant.quantityMax != null && Number(quantity.value) > Number(variant.quantityMax)) {
          quantity.value = String(variant.quantityMax);
        }
      }

      if (addButton && addLabel) {
        addButton.disabled = !variant.available;
        addLabel.textContent = variant.available ? 'Ajouter au panier' : 'Indisponible';
      }

      if (sellingPlanField && sellingPlanSelect) {
        const plans = Array.isArray(variant.sellingPlans) ? variant.sellingPlans : [];
        sellingPlanSelect.replaceChildren();

        if (!variant.requiresSellingPlan) {
          const oneTimeOption = document.createElement('option');
          oneTimeOption.value = '';
          oneTimeOption.textContent = 'Achat unique';
          sellingPlanSelect.append(oneTimeOption);
        }

        plans.forEach((plan) => {
          const option = document.createElement('option');
          option.value = String(plan.id);
          option.textContent = `${plan.name} — ${plan.price}`;
          sellingPlanSelect.append(option);
        });

        sellingPlanField.hidden = plans.length === 0;
        sellingPlanSelect.disabled = plans.length === 0;
        sellingPlanSelect.required = Boolean(variant.requiresSellingPlan && plans.length);
      }

      if (updateUrl && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', String(variant.id));
        window.history.replaceState({}, '', url);
      }
    };

    variantSelect.addEventListener('change', () => {
      const variant = variantsById.get(variantSelect.value);
      updateVariant(variant);
      announce(variant?.available ? 'Option sélectionnée et disponible' : 'Option indisponible');
    });

    section.dataset.productReady = 'true';
  };

  const initProductSections = (scope = document) => {
    if (scope.matches?.('[data-product-section]')) initProductSection(scope);
    scope.querySelectorAll?.('[data-product-section]').forEach(initProductSection);
  };

  const showToast = (message, isError = false) => {
    const toast = document.querySelector('[data-cart-toast]');
    const label = toast?.querySelector('[data-cart-toast-text]');
    if (!toast || !label) return;
    label.textContent = message;
    toast.classList.toggle('is-error', isError);
    toast.classList.add('is-visible');
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => toast.classList.remove('is-visible'), 3200);
  };

  const updateCartCount = async () => {
    const rootPath = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => {
      node.textContent = String(cart.item_count || 0);
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mobile-menu-toggle]');
    if (toggle) {
      const menu = document.querySelector('[data-mobile-menu]');
      if (!menu) return;
      const isOpen = menu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('menu-open', isOpen);
      announce(isOpen ? 'Menu ouvert' : 'Menu fermé');
      return;
    }

    const close = event.target.closest('[data-mobile-menu-close]');
    if (close) {
      const menu = document.querySelector('[data-mobile-menu]');
      const toggleButton = document.querySelector('[data-mobile-menu-toggle]');
      menu?.classList.remove('is-open');
      toggleButton?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      announce('Menu fermé');
      return;
    }

    const navLink = event.target.closest('[data-mobile-menu] a');
    if (navLink) {
      document.querySelector('[data-mobile-menu]')?.classList.remove('is-open');
      document.querySelector('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('[data-mobile-menu]');
    if (!menu?.classList.contains('is-open')) return;
    menu.classList.remove('is-open');
    document.querySelector('[data-mobile-menu-toggle]')?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('menu-open');
  });

  document.querySelectorAll('[data-quantity-input]').forEach((input) => {
    input.addEventListener('change', () => {
      if (input.valueAsNumber < 0) input.value = '0';
    });
  });

  document.querySelectorAll('[data-auto-submit]').forEach((field) => {
    field.addEventListener('change', () => field.form?.submit());
  });

  document.querySelectorAll('.kk-category-details').forEach((details) => {
    details.addEventListener('toggle', () => {
      if (!details.open) return;
      document.querySelectorAll('.kk-category-details[open]').forEach((other) => {
        if (other !== details) other.removeAttribute('open');
      });
    });
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('.kk-category-details')) return;
    document.querySelectorAll('.kk-category-details[open]').forEach((details) => details.removeAttribute('open'));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.kk-card-form');
    if (!form || !window.fetch) return;
    event.preventDefault();

    const button = form.querySelector('button[type="submit"]');
    const originalLabel = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Ajout…';
    }

    try {
      const rootPath = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Ajout impossible');
      await updateCartCount();
      showToast(`${payload.product_title || 'Produit'} ajouté au panier`);
      announce('Produit ajouté au panier');
    } catch (error) {
      showToast(error.message || 'Ce produit ne peut pas être ajouté pour le moment.', true);
      announce('Erreur lors de l’ajout au panier');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  });

  initProductSections();
  document.addEventListener('shopify:section:load', (event) => initProductSections(event.target));
})();
